import React from 'react';
import './RouteLoading.css';

const RouteLoading = ({ compact = false }) => (
  <div
    className={`route-loading${compact ? ' route-loading--compact' : ''}`}
    role="status"
    aria-live="polite"
    aria-label="Cargando contenido"
  >
    <div className="route-loading__content">
      <div className="route-loading__mark" aria-hidden="true">
        <span className="route-loading__halo" />
        <span className="route-loading__brand">nua.</span>
      </div>
      <span className="route-loading__label">Preparando tu espacio</span>
      <div className="route-loading__track" aria-hidden="true">
        <span />
      </div>
    </div>
  </div>
);

export default RouteLoading;
